import { INPUT_YES_NO_SEARCH_FIELDS } from '@app/constants/Common';
import React, {useEffect} from 'react';

const InputYesNoSearch = ({ 
    initInputYesNo, 
    onChange
}) => {

    const [inputYesNo, setInputYesNo] = React.useState({
        checkedFields: {}
    });

    useEffect(() => {
        setInputYesNo({...initInputYesNo});
    }, [initInputYesNo]);

    const onChangeCheckInputItem = (event, fieldKey) => {
        console.log("onChangeCheckInputItem:" + event.target.value)
        const {checkedFields} = inputYesNo
        const currentChecked = checkedFields[event.target.name]
        checkedFields[event.target.name] = !currentChecked;
        if (!checkedFields[event.target.name]) {
            inputYesNo[fieldKey] = "";
        }
        setInputYesNo({...inputYesNo});
        if (onChange) {
            onChange(inputYesNo);
        }
    };

    const onChangeInputYesNo = (event) => {
        console.log("onChangeInputYesNo:" + event.target.value)
        inputYesNo[event.target.name] = event.target.value;
        setInputYesNo({...inputYesNo});
        if (onChange) {
            onChange(inputYesNo);
        }
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Nhập liệu rồi/chưa</h3>
            </div>
            <div className='card-body row'>
                {INPUT_YES_NO_SEARCH_FIELDS.map(item => (
                    <div key={item.key} className={"col-sm-3"}>
                        <label id={`checkInputItem_${item.key}`} className={"mr-3"}>{item.label}</label>
                        <input type="checkbox" name={`isInput${item.key}`}
                               id={`checkInputItem_${item.key}`}
                               defaultChecked={!!inputYesNo.checkedFields[`isInput${item.key}`]}
                               style={{height: 20, width: 20, verticalAlign: 'middle'}}
                               onChange={event => onChangeCheckInputItem(event, item.key)}
                        />
                        <div className="mx-2">
                            <input type="radio" name={item.key}
                                   id={`inputYesItem_${item.key}`}
                                   value={"yeszz"}
                                   disabled={!inputYesNo.checkedFields[`isInput${item.key}`]}
                                   checked={inputYesNo[item.key] === 'yeszz'}
                                   style={{height: 20, width: 20, verticalAlign: 'middle'}}
                                   onChange={event => onChangeInputYesNo(event)}
                            />
                            <label className={"ml-2"} htmlFor={`inputYesItem_${item.key}`}>
                                {'Đã nhập'}
                            </label>
                        </div>
                        <div className="mx-2">
                            <input type="radio" name={item.key}
                                   id={`inputNoItem_${item.key}`}
                                   value={"blankzz"}
                                   disabled={!inputYesNo.checkedFields[`isInput${item.key}`]}
                                   checked={inputYesNo[item.key] === 'blankzz'}
                                   defaultValue={inputYesNo[item.key]}
                                   style={{height: 20, width: 20, verticalAlign: 'middle'}}
                                   onChange={event => onChangeInputYesNo(event)}
                            />
                            <label className={"ml-2"} htmlFor={`inputNoItem_${item.key}`}>
                                {'Chưa nhập'}
                            </label>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InputYesNoSearch;
